import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteExchangeRateDisclaimer', {
    manualRate: 'Manual exchange rate will be applied, 1 {selectedCurrency} = {exchangeRate} {defaultCurrency}.',
    autoRate: 'Currency rate {exchangeRate} for {date} provided by Oracle NetSuite, will be applied after submission.',
});
